import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useClubIsSellingPackages_club$key } from "./__generated__/useClubIsSellingPackages_club.graphql";

export const useClubIsSellingPackages = (
  clubRef: useClubIsSellingPackages_club$key | null | undefined
) => {
  const club = useFragment(useClubIsSellingPackagesFragment, clubRef);

  return (club?.packages?.count ?? 0) > 0;
};

const useClubIsSellingPackagesFragment = graphql`
  fragment useClubIsSellingPackages_club on Club {
    packages(packageType: $packageType, saleAvailability: PUBLIC) {
      count
    }
  }
`;
